export default "__VITE_ASSET__sErlISro__"